// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map_stE9N","info":"Map_info_7TQes"};